import pushEventToDataLayer from '../../../../../push-event-to-data-layer'

const displayPinpoll = () => {
  if (document.getElementById('appLoginLinkPinpoll')) {
    document.getElementById('appLoginLinkPinpoll').style = 'display:none;'
  }
  pushEventToDataLayer('pinpollDMPResultShown')
  const pinPoll = document.getElementById('pinpollParentNode')
  pinPoll.style = 'visibility:visible;'
}

export default displayPinpoll
